import { AxiosInstance } from "@bps/http-client";

import {
  UnavailabilityDto,
  UnavailabilityResponseDto,
  UnavailabilityUpdateDto
} from "./unavailability.dtos";
import { mapDatesToStrings, mapStringsToDates } from "./unavailability.utils";

export class UnavailabilityGateway {
  constructor(private api: AxiosInstance) {}

  public getExclusionPeriodsForLocation = async (
    locationId: string
  ): Promise<UnavailabilityDto[]> => {
    const { data } = await this.api.get<UnavailabilityResponseDto[]>(
      `unavailability?locationId=${locationId}`
    );

    return data.map(mapStringsToDates);
  };

  public addExclusionPeriod = async (
    exclusionPeriod: UnavailabilityUpdateDto
  ): Promise<UnavailabilityDto> => {
    const { data } = await this.api.post<UnavailabilityResponseDto>(
      "unavailability",
      mapDatesToStrings(exclusionPeriod)
    );
    return mapStringsToDates(data);
  };

  public updateExclusionPeriod = async (
    exclusionPeriod: UnavailabilityUpdateDto
  ): Promise<UnavailabilityDto> => {
    const { data } = await this.api.put<UnavailabilityResponseDto>(
      `unavailability/${exclusionPeriod.id}`,
      mapDatesToStrings(exclusionPeriod),
      {
        headers: {
          eTag: exclusionPeriod.eTag
        }
      }
    );

    return mapStringsToDates(data);
  };

  public deleteExclusionPeriod = async (id: string): Promise<boolean> => {
    const { data } = await this.api.delete<boolean>(`unavailability/${id}`);
    return data;
  };
}
